import React, { JSX, useState, useEffect } from 'react';
import { seatCounts } from "../../../../../defaults/defaults";
import { Close, Add, Check } from '@mui/icons-material';
import { convertCurrencyToSymbol } from "../../../../../defaults/defaults";

export const SubscriptionManagerMiniCard: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const product: any = props.product;
    let startingSeatCount: number = 3;
    const activeSubscription = props.activeSubscription;
    const activeFrequency: string = props.activeFrequency;
    const [seatCount, setSeatCount] = useState<number>(0);
    const [customPrice, setCustomPrice] = useState<number>(8);
    const [customSeats, setCustomSeats] = useState<number>(50);
    const [activeSeats, setActiveSeats] = useState<number>(0);
    const [usingCustomData, setUsingCustomData] = useState<boolean>(false);
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [initialLoading, setInitialLoading] = useState<boolean>(false);
    let intial: boolean = false;


    function handleSeatCountToggle(event: any) :void {
        let num: number = event.target.value;
        setSeatCount(num);
        if (num >= 50) {
            setUsingCustomData(true);
        } else {
            setUsingCustomData(false);
        }
    }

    function handleCustomPriceChange(event: any) :void {
        setCustomPrice(event.target.value);
    }

    function handleCustomSeatChange(event: any) :void {
        let customSeats: number = event.target.value;
        if (product.name.toLowerCase().includes('enterprise') && customSeats < 10) {
            customSeats = 10;
        }

        setCustomSeats(customSeats);
    }

    function addSubscriptionProduct(): void {
        setIsUpdating(true);
        let price: -1;
        if (!product.name.toLowerCase().includes('enterprise')) {
            price = product?.prices[activeFrequency].id
        }

        props.handleActiveSubscriptionProductUpdate({
            product: product.id,
            price: price,
            seats: seatCount,
            customPrice: customPrice,
            customSeats: customSeats,
            usingCustomData: usingCustomData,
            activeSeats: activeSeats,
            tier: product.tier
        } )
    }

    function removeSubscriptionProduct(): void {
        setIsUpdating(false);
        let price: -1;
        if (!product.name.toLowerCase().includes('enterprise')) {
            price = product?.prices[activeFrequency].id
        }
        props.handleActiveSubscriptionProductRemove(
            {
                product: product.id,
                price: price,
                seats: seatCount,
                customPrice: customPrice,
                customSeats: customSeats,
                usingCustomData: usingCustomData,
                activeSeats: activeSeats,
                tier: product.tier
            }
        );
    }

    function updateSubscriptionProduct(): void {
        setIsUpdating(true);
        props.handleUpdateActiveSubscriptionProductItem({
            product: product.id,
            price: product?.prices[activeFrequency].id,
            seats: seatCount,
            customPrice: customPrice,
            customSeats: customSeats,
            usingCustomData: usingCustomData,
            activeSeats: activeSeats,
            tier: product.tier
        } )
    }
    // console.log(product);
    useEffect( (): void =>  {
        const tierStartingSeats = {
            "1": 1,
            "2": 1,
            "3": 2,
            "4": 5,
            "5": 6,
            "6": 1,
        }

        if (props.isActiveSubscriptionProduct( product.id) || props?.activeSubscriptionProductData?.length) {
            if (isUpdating === false && initialLoading === false) {
                // debugger;
                const subscriptionConfiguration: any = activeSubscription?.configuration ?? [];
                for (let i: number = 0; i < subscriptionConfiguration.length; i++) {
                    const config: any = subscriptionConfiguration[i];
                    if (config.product === product.id) {
                        setSeatCount(config.seats);
                        setUsingCustomData(config.usingCustomData);
                        setActiveSeats(config.activeSeats);
                        if (config.usingCustomData === true) {
                            setCustomPrice(config.customPrice);
                            setSeatCount(50);
                            setCustomSeats(config.customSeats);
                        }
                        break;
                    }
                }
                setInitialLoading(true);
            }
            // if ( (!props.subscriptionChanged && isUpdating === true) || props.subscriptionChanged) {
            //     // debugger;
            //     for (let i: number = 0; i < props?.activeSubscriptionProductData?.length; i++) {
            //         const config: any = props.activeSubscriptionProductData[i];
            //         if (config.product === product.id) {
            //             // debugger;
            //             setSeatCount(parseInt(config.seats));
            //             setUsingCustomData(config.usingCustomData);
            //             setActiveSeats(config.activeSeats);
            //             if (config.usingCustomData) {
            //                 // let customPrices = product.prices['custom'];
            //                 // let p: number = 0;
            //                 // for (const pr of customPrices) {
            //                 //     if (pr.id === config.product) {
            //                 //         p = pr.price;
            //                 //     }
            //                 // }
            //                 setSeatCount(50);
            //                 setCustomSeats(config.customSeats);
            //                 setCustomPrice(config.customPrice);
            //             }
            //         }
            //     }
            //     if (!props.subscriptionChanged && isUpdating === true) {
            //         setIsUpdating(false);
            //     }
            //
            // }

        } else if (seatCount === 0 && props?.activeSubscriptionProductData?.length <= 0) {
            let startingSeatCount: number = 3;
            if (product) {
                startingSeatCount = tierStartingSeats[product.tier];
            }
            if (product.name.toLowerCase().includes('enterprise')) {
                startingSeatCount = 10
                setSeatCount(50);
                setUsingCustomData(true);
                setCustomSeats(startingSeatCount);
            } else {
                setSeatCount(startingSeatCount);
            }

        }
    }, [product, props, activeSubscription, seatCount, isUpdating, initialLoading] );

    return (
        <div className={ "tiers__tier" }>
            <div className="tier__data">
                { (!product.name.toLowerCase().includes('enterprise')) &&
                    <div className="tier__seats">
                        <span>{ parseInt(product.tier) < 6 ? 'Seats' : 'Quantity' }</span>
                        { (parseInt(product.tier) < 6) &&
                            <select value={ seatCount }
                                    disabled={ props.updatingSubscription || ( activeSubscription?.status === 'canceled' ) }
                                    onChange={ (e: any): void => handleSeatCountToggle(e) } >
                                { new Array(49).fill('').map( (_: any, index: number): JSX.Element => {
                                    return (
                                        <option value={ (index + 1) } key={ index }>{ (index + 1) }</option>
                                    );
                                } ) }
                                <option value={ 50 } >{ "50+" }</option>
                            </select>
                        }
                        { (parseInt(product.tier) >= 6) &&
                            <input type="number" value={ seatCount } onChange={ (e: any): void => handleSeatCountToggle(e) }  />
                        }

                    </div>
                }
                <span className="tier__price">
                    { (seatCount < 50) &&
                        <>
                            { convertCurrencyToSymbol(props.activeCurrency) + ( (product?.prices[activeFrequency].price * seatCount).toFixed(2)  ) + ' / '}
                            <span>{ activeFrequency }</span>
                        </>
                    }
                    { (seatCount >= 50) &&
                        <>
                            { convertCurrencyToSymbol(props.activeCurrency) + (customPrice * customSeats) + ' / '}
                            <span>{ activeFrequency }</span>
                        </>
                    }
                </span>
            </div>
            <div className="tier__custom">
                { (product && parseInt(product.tier) < 6) &&
                    <>
                        <div className="custom__item">
                            <span className={ (seatCount < 50 ? 'disabled' : '') } >{ "Custom seat price" }</span>
                            <input type="number"
                                   disabled={ activeSubscription?.status === 'canceled' || (seatCount < 50) }
                                   value={ customPrice }
                                   onChange={ handleCustomPriceChange } />
                        </div>
                        <div className="custom__item">
                            <span className={ (seatCount < 50 ? 'disabled' : '') } >{ "Custom number of seats" }</span>
                            <input type="number"
                                   disabled={ activeSubscription?.status === 'canceled' || (seatCount < 50) }
                                   value={ customSeats }
                                   onChange={ handleCustomSeatChange } />
                        </div>
                    </>
                }

            </div>
            <div className="tier__actions">
                { (!props.isActiveSubscriptionProduct(product.id )) &&
                    <button className="tier__add"
                            type="button"
                            disabled={ props.updatingSubscription || ( activeSubscription?.status === 'canceled' ) || (props?.activeSubscriptionProductData?.length <= 0 && parseInt(product.tier) >= 6 ) }
                             onClick={ addSubscriptionProduct  }
                        >
                        { "Add " }
                        <Add />
                    </button>
                }
                { (props.isActiveSubscriptionProduct(product.id )) &&
                    <>
                        <button className="tier__check"
                                type="button"
                                disabled={ props.updatingSubscription || ( activeSubscription?.status === 'canceled' ) }
                                onClick={ updateSubscriptionProduct }
                            >
                            { "Update" }
                            <Check />
                        </button>
                        <button className="tier__cross"
                                type="button"
                                disabled={ props.updatingSubscription || ( activeSubscription?.status === 'canceled' ) }
                                onClick={ removeSubscriptionProduct }
                            >
                            { "Remove" }
                            <Close />
                        </button>
                    </>
                }
            </div>
        </div>
    );
}